import {Style,Icon} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
const schoolPoiStyle = 
new Style({
  image: new Icon({
    anchor: [0.5, 46],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: 'data/icons/24px/school.png',
    color: '#F2B705',
    scale: 0.7
  }),
});


const schoolVector = new VectorSource({
url: 'data/india/UP/point_of_interest_COMSCH.json',
format: new TopoJSON({
  layers: ['COMSCH'],
}),
overlaps: true,
});


export const poiSchoolLayer = new VectorLayer({
// source: new Cluster({
//   source: schoolVector,
// }),
//minZoom: POI_MIN_ZOOM_LEVEL - 2,
source: schoolVector,
style: schoolPoiStyle,
visible: true,
zIndex : 2
});
